import React, {PureComponent} from 'react';

import logo from "../../img/logo_small.png";
import gsm_0 from "../../img/gsm/gsm_0.svg";
import gsm_1 from "../../img/gsm/gsm_1.svg";
import gsm_2 from "../../img/gsm/gsm_2.svg";
import gsm_3 from "../../img/gsm/gsm_3.svg";
import gsm_4 from "../../img/gsm/gsm_4.svg";
import gsm_5 from "../../img/gsm/gsm_5.svg";

import $ from "jquery";
import {formatTime, calculateAVGSpeed} from "../functions/utils";
import ReactTooltip from 'react-tooltip';
import {subscribeToDriverChangeInfo, subscribeNotifyDriverChange, subscribeClock} from "../functions/api";
import Alert from "react-s-alert";
import LoggingBox from "../popoutComponents/loggingBox";
import ReplyModal from "../independentComponents/replyModalComponent";
import OrgMessageModal from "../independentComponents/orgMessageModalComponent";
import MessageComponent from "../independentComponents/messageComponent";
import DiagnosticModal from "../independentComponents/diagnosticModal";
import CustomProgressBar from "../independentComponents/progressBar";
import SeatTimeAlertModal from "../independentComponents/seatTimeAlertModal";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const event_admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);

class TopRow extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            isPoppedOut: false,
            deviceStatusLEDcolor: "yellow",
            deviceStatusTooltip: "Unknown state",
            gpsStatusLEDcolor: "yellow",
            gpsStatusTooltip: "Unknown state",
            gsmStatusLEDcolor: "yellow",
            gsmStatusTooltip: "Unknown state",
            gsmIcon: gsm_0,
        };

        this.getDeviceStatusLED = this.getDeviceStatusLED.bind(this);
    }

    getDeviceStatusLED(device_on_led_color, device_on_tooltip, gps_led_color, gps_tooltip, gsm_tooltip, gsm_led_color, gsm_icon) {
        let gsmSignal;
        switch (gsm_icon) {
            case ("gsm_0"): {
                gsmSignal = gsm_0;
                break;
            }
            case ("gsm_1"): {
                gsmSignal = gsm_1;
                break;
            }
            case ("gsm_2"): {
                gsmSignal = gsm_2;
                break;
            }
            case ("gsm_3"): {
                gsmSignal = gsm_3;
                break;
            }
            case ("gsm_4"): {
                gsmSignal = gsm_4;
                break;
            }
            case ("gsm_5"): {
                gsmSignal = gsm_5;
                break;
            }
            default: {
                gsmSignal = gsm_0;
                break;
            }
        }

        this.setState({
            deviceStatusLEDcolor: device_on_led_color,
            deviceStatusTooltip: device_on_tooltip,
            gpsStatusLEDcolor: gps_led_color,
            gpsStatusTooltip: gps_tooltip,
            gsmStatusLEDcolor: gsm_led_color,
            gsmStatusTooltip: gsm_tooltip,
            gsmIcon: gsmSignal,
        });
    }

    render() {
        return (
            <>
                <div className={"row"}>
                    <div className={"col-sm-12 col-md-8"}>
                        <div className={"App_sectionContainer"} style={{borderRadius: "0 0 35px 0"}}>
                            <div className={"col-xs-12 row-flex"} style={{padding: 0}}>
                                <CurrentDriver
                                    userID={this.props.userID}
                                    isGuest={this.props.isGuest}
                                    sessionID={this.props.sessionID}
                                    eventID={this.props.eventID}
                                    carID={this.props.carID}
                                    carObj={this.props.carObj}
                                    eventShareCode={this.props.eventShareCode}
                                    isOwnTeam={this.props.isOwnTeam}
                                    instructionFlag={this.props.instructionFlag}
                                    convertFlags={this.props.convertFlags}
                                    deviceStatusGetter={this.getDeviceStatusLED}
                                    lastComm={this.props.telemetry.srt}
                                    privileges={this.props.privileges}
                                    pendingMsgOrg={this.props.pendingMsgOrg}
                                    pendingMsgTeam={this.props.pendingMsgTeam}
                                    showSeatTime={this.props.showSeatTime}
                                    seatTimeLimitAlert={this.props.seatTimeLimitAlert}
                                    sessionActive={this.props.sessionActive}
                                    startTimestamp={this.props.startTimestamp}
                                    t={this.props.t}
                                    cookies={this.props.cookies}
                                    marshallPosts={this.props.marshallPosts}
                                    preSelectTeamCar={this.props.preSelectTeamCar}
                                />
                                <Position
                                    carID={this.props.carID}
                                    numLaps={this.props.numLaps}
                                    currentCarPosition={this.props.currentCarPosition}
                                    t={this.props.t}
                                    cookies={this.props.cookies}
                                />
                            </div>
                            <Logo
                                deviceStatusLEDcolor={this.state.deviceStatusLEDcolor}
                                deviceStatusTooltip={this.state.deviceStatusTooltip}
                                gpsStatusLEDcolor={this.state.gpsStatusLEDcolor}
                                gpsStatusTooltip={this.state.gpsStatusTooltip}
                                gsmStatusLEDcolor={this.state.gsmStatusLEDcolor}
                                gsmStatusTooltip={this.state.gsmStatusTooltip}
                                gsmIcon={this.state.gsmIcon}
                                t={this.props.t}
                                cookies={this.props.cookies}
                            />
                            <div className={"col-xs-12 row-flex"} style={{padding: 0}}>
                                <div className={"col-xs-12 col-md-4"} style={{padding: 0}}>
                                    <LapTimes
                                        currentLapTime={this.props.telemetry.clt}
                                        standings={this.props.standings}
                                        carID={this.props.carID}
                                        bestLapOverall={this.props.bestLapOverall}
                                        bestLapPersonal={this.props.bestLapPersonal}
                                        orderType={this.props.orderType}
                                        t={this.props.t}
                                        cookies={this.props.cookies}
                                    />
                                </div>
                                <div className={"col-xs-12 col-md-8"} style={{padding: 0}}>
                                    <LapTable
                                        eventID={this.props.eventID}
                                        laps={this.props.laps}
                                        carID={this.props.carID}
                                        circuitLength={this.props.circuitLength}
                                        t={this.props.t}
                                        cookies={this.props.cookies}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"col-sm-12 col-md-4"} style={$(window).width() > 1200 ? {} : {marginTop: 10}}>
                        <div className={"App_sectionContainer"}>
                            <Gauges
                                gaugesConfig={this.props.gaugesConfig}
                                telemetry={this.props.telemetry}
                                isOwnTeam={this.props.isOwnTeam}
                                speedSource={this.props.speedSource}
                                isGuest={this.props.isGuest}
                                privileges={this.props.privileges}
                                t={this.props.t}
                                cookies={this.props.cookies}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

class CurrentDriver extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            picSrc: serverIP + ":" + backendPort + "/uploads/noimage.png",
            teamName: "---",
            drivers: [
                {id: -1, name: ""},
            ],
            currentDriver: {id: -1, name: ""},
            currentDriverID: -1,
            currentDriverSeatTime: 0,
            seatTimeSum: 0,
            seatTimeLastTimestamp: 0,
            now: new Date().getTime(),
        };

        this.handleDriverChange = this.handleDriverChange.bind(this);
        this.popoutTeamInfo = this.popoutTeamInfo.bind(this);
        this.getDriverSeatTime = this.getDriverSeatTime.bind(this);
        this.handleSeatTimeClock = this.handleSeatTimeClock.bind(this);
    }

    /* LIFECYCLE */
    componentDidMount() {
        // Pre-select teamcar, only after this component is mounted
        this.props.preSelectTeamCar();
        // Listen to any driver changes
        subscribeToDriverChangeInfo(this.props.eventID, false, (err, driverInfo) => {
            if (parseInt(this.props.carID) === parseInt(driverInfo.cid)) {
                this.setState({
                    currentDriverID: driverInfo.did,
                }, () => {
                    Alert.info('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("driverChanged") + '!</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });

                    // Update combo-box with other driver's times
                    for (let i = 0; i < this.state.drivers.length; i++) {
                        if (this.state.drivers[i].id === this.state.previousDriverID) {
                            let temp = this.state.drivers.slice();
                            const currentShift = Math.abs(this.state.seatTimeLastTimestamp - this.state.now);
                            temp[i].seat_time = (this.state.seatTimeSum + currentShift);
                            this.setState({
                                drivers: temp,
                            });
                            break;
                        }
                    }

                    // Update current driver object for later use
                    for (let i = 0; i < this.state.drivers.length; i++) {
                        if (driverInfo.did === this.state.drivers[i].id) {
                            this.setState({
                                currentDriver: this.state.drivers[i],
                                seatTimeLastTimestamp: driverInfo.tim,
                            }, () => {
                                this.getDriverSeatTime(driverInfo.tim);
                            });
                            break;
                        }
                    }
                });
            }
        });
        // Subscriber server clock
        subscribeClock((obj) => {
            this.setState({
                now: obj.tim
            });
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.startTimestamp !== this.props.startTimestamp) {
            this.setState({
                seatTimeLastTimestamp: this.state.now,
            }, () => {
                this.handleSeatTimeClock();
            });
        }
        if (prevProps.carID !== this.props.carID) {
            $(".loading").fadeIn();
            const helper = this;
            $.ajax({
                type: 'POST',
                url: serverIP + ":" + backendPort + '/dashboard/getCarDetails',
                headers: {
                    'authorization': helper.props.cookies.get("authToken"),
                    'eventsharecode': helper.props.eventShareCode,
                },
                data: {
                    userID: helper.props.userID,
                    carID: helper.props.carID,
                    sessionID: helper.props.sessionID,
                    eventID: helper.props.eventID,
                },
                success: function (data) {
                    try {
                        let found = false;
                        for (let i = 0; i < data.drivers.length; i++) {
                            if (data.current_driver_id === data.drivers[i].id) {
                                helper.setState({
                                    currentDriver: data.drivers[i],
                                }, () => {
                                    helper.getDriverSeatTime(null);
                                });
                                found = true;
                                break;
                            }
                        }

                        // Make fadeout if no driver is preset
                        if (!found) {
                            $(".loading").fadeOut();
                        }

                        helper.setState({
                            picSrc: (data.pic_path ? serverIP + ":" + backendPort + "/uploads/" + data.pic_path : helper.state.picSrc),
                            shortName: data.short_name,
                            teamName: data.team_name,
                            drivers: data.drivers,
                            fullData: data,
                            carID: parseInt(helper.props.carID),
                            currentDriverID: data.current_driver_id,
                            liveryID: data.livery_number,
                            teamOnlyMessage: false,
                        });
                    } catch (e) {
                        if (e) {
                            console.error('Error:', e);
                        }
                    }
                }, error: function (err) {
                    if (err) {
                        console.error('Error:', err);
                    }
                }
            });
        }
    }

    componentWillUnmount() {
        subscribeToDriverChangeInfo(this.props.eventID, true, null);
        clearInterval(this.seatTimer);
        subscribeClock(null);
    }

    /* HANDLERS */
    handleDriverChange(e) {
        for (let i = 0; i < this.state.drivers.length; i++) {
            if (this.state.drivers[i].id === parseInt(e.target.value)) {
                // Update component state
                this.setState({
                    currentDriver: this.state.drivers[i],
                    currentDriverID: e.target.value,
                    previousDriverID: this.state.currentDriverID,
                });
                console.log("[DASHBOARD] =>", this.state.drivers[i].name, "now driving");
                // Write to MySQL
                subscribeNotifyDriverChange(
                    this.state.drivers[i].id,
                    this.props.carID,
                    this.props.sessionID,
                    this.props.eventID,
                    this.props.carObj.edr_id,
                    (msg) => {
                        console.log("[DRIVER NAME COMPONENT]", msg);
                    });
                // No need to go through other drivers
                break;
            }
        }
    }

    handleSeatTimeClock() {
        clearInterval(this.seatTimer);
        if (this.state.seatTimeLastTimestamp > 0 && (this.props.sessionActive === '2' && this.props.startTimestamp > 0)) {
            this.seatTimer = setInterval(() => {
                const currentShift = Math.abs(this.state.seatTimeLastTimestamp - this.state.now);
                this.setState({
                    currentDriverSeatTime: (this.state.seatTimeSum + currentShift),
                });
            }, 1000);
        }
    }

    /* DATA */
    popoutTeamInfo() {
        window.open(
            "/teamInfo/" + this.props.userID + "/" + this.props.carID + "/" + this.props.sessionID + "/" + this.props.eventID,
            'team',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=-350,top=100,width=1000,height=920"
        );
    }

    getDriverSeatTime(lastChangeTimestamp) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getDriverSeatTime',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.sessionID,
                driverID: helper.state.currentDriver.id,
                carID: helper.props.carID,
            },
            success: function (data) {
                helper.setState({
                    seatTimeSum: data.sum,
                    seatTimeLastTimestamp: lastChangeTimestamp !== null ? lastChangeTimestamp : data.last_timestamp,
                }, () => {
                    helper.handleSeatTimeClock();
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        }).done(() => {
            $(".loading").fadeOut();
        });
    }

    render() {
        let driverName;
        let name = "";
        if (this.props.isOwnTeam === 1) {
            driverName = (
                <select value={(this.state.currentDriverID ? this.state.currentDriverID : "")}
                        onChange={this.handleDriverChange}
                        className={"form-control"}>
                    <option key={-1} value={-1}>{this.props.t("selectDriver")}!</option>
                    {this.state.drivers.map((driver) => {
                        name = this.state.currentDriver.name;
                        return (
                            <option
                                key={driver.id}
                                value={driver.id}
                            >{driver.name}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                {this.props.showSeatTime === 1 ? (
                                    (this.state.currentDriverID !== driver.id ? (formatTime(driver.seat_time).slice(0, -4)) : "")
                                ) : null}
                            </option>
                        );
                    })}
                </select>
            );
        } else {
            let temp = "---";
            if (this.state.drivers) {
                for (let i = 0; i < this.state.drivers.length; i++) {
                    if (parseInt(this.state.drivers[i].id) === parseInt(this.state.currentDriverID)) {
                        temp = this.state.drivers[i].name;
                        name = temp;
                        break;
                    }
                }
                driverName = (
                    <p>
                        <span key={0} className={"App_driverName_title"}>{this.props.t("driver")}: </span>,
                        <span key={1} className={"App_driverName_name"}>{temp}</span>
                    </p>
                );
            }
        }

        return (
            <div className={"col-xs-10 currentDriverContainerStyle row-flex"}>
                {(this.props.showSeatTime === 1 && this.props.isOwnTeam === 1) ? (
                    <SeatTimeAlertModal
                        sessionActive={this.props.sessionActive}
                        seatTimeSum={this.state.seatTimeSum}
                        driverName={this.state.currentDriver.name}
                        seatTimeLastTimestamp={this.state.seatTimeLastTimestamp}
                        seatTimeLimitAlert={this.props.seatTimeLimitAlert}
                        startTimestamp={this.props.startTimestamp}
                    />
                ) : null}
                <ReplyModal
                    carID={this.props.carID}
                    driverName={this.state.currentDriver.name}
                    driverID={this.state.currentDriver.id}
                    sessionID={this.props.sessionID}
                    eventID={this.props.eventID}
                    pendingMsgOrg={this.props.pendingMsgOrg}
                    pendingMsgTeam={this.props.pendingMsgTeam}
                    privileges={this.props.privileges}
                />
                <OrgMessageModal
                    carID={this.props.carID}
                    driverName={this.state.currentDriver.name}
                    sessionID={this.props.sessionID}
                    eventID={this.props.eventID}
                    liveryID={this.state.liveryID}
                    privileges={this.props.privileges}
                />
                <div className={"col-xs-2 dashboardFlagDriverContainer"}>
                    <img className={"organizerPanel_flagStyle w3-animate-fading " + (this.props.instructionFlag ? "blink" : "")}
                         alt={"PIC"}
                         style={{margin: 0}}
                         src={this.props.instructionFlag ? (serverIP + ":" + backendPort + "/images/flags/" + this.props.instructionFlag.src) : (serverIP + ":" + backendPort + "/images/flags/none_transparent.png")}
                    />
                </div>
                <div className={this.props.showSeatTime === 1 ? "col-xs-5" : "col-xs-7"}>
                    <span className={"App_teamTitle"}>{this.state.teamName}</span>
                    {this.state.drivers ? (<>{driverName}</>) : null}
                </div>
                {this.props.showSeatTime === 1 ? (
                    <div className={"col-xs-3"}>
                        <div className={"App_title"}>{this.props.t("seatTime")}</div>
                        <div className={"App_header"}>{this.state.currentDriverSeatTime === 0 ? "00:00:00" : formatTime(this.state.currentDriverSeatTime).slice(0, -4)}</div>
                    </div>
                ) : null}
                <div className={"col-xs-3"} style={{paddingRight: 5, paddingLeft: 5}}>
                    <div className={"col-xs-6"} style={{padding: 2}}>
                        {!this.props.isGuest ? (
                            <MessageComponent
                                disable={this.state.currentDriverID === null || this.state.currentDriverID < 0}
                                isGuest={this.props.isGuest}
                                carID={this.props.carID}
                                isOwnTeam={this.props.isOwnTeam}
                                driverName={name}
                                liveryNumber={this.props.carObj.livery_number}
                                eventID={this.props.eventID}
                                sessionID={this.props.sessionID}
                                userID={this.props.userID}
                                privileges={this.props.privileges}
                                pendingMsgOrg={this.props.pendingMsgOrg}
                                pendingMsgTeam={this.props.pendingMsgTeam}
                            />
                        ) : null}
                    </div>
                    <div className={"col-xs-6"} style={{padding: 2}}>
                        <button
                            type={"button"}
                            data-tip={true}
                            data-for={"teamInfo"}
                            className={"btn btn-primary btn-block button"}
                            onClick={this.popoutTeamInfo}
                            disabled={!this.props.carID}
                        >
                            <i className={"fas fa-address-card App_buttonContainer_icons"}/>
                        </button>
                    </div>
                    {!this.props.isGuest ? (
                        <>
                            <div className={"col-xs-6"} style={{padding: 2}}>
                                <LoggingBox
                                    carID={this.props.carID}
                                    teamName={"#" + this.props.carObj.livery_number + " " + this.props.carObj.team_name}
                                    sessionID={this.props.sessionID}
                                    userID={this.props.userID}
                                    isOwnTeam={this.props.isOwnTeam}
                                    disabled={parseInt(this.props.isOwnTeam) !== 1}
                                    convertFlags={this.props.convertFlags}
                                    isSessionChoice={false}
                                    privileges={this.props.privileges}
                                    marshallPosts={this.props.marshallPosts}
                                />
                            </div>
                            <div className={"col-xs-6"} style={{padding: 2}}>
                                <DiagnosticModal
                                    carID={this.props.carID}
                                    carObj={this.props.carObj}
                                    sessionID={this.props.sessionID}
                                    eventID={this.props.eventID}
                                    deviceStatusGetter={this.props.deviceStatusGetter}
                                    lastComm={this.props.lastComm}
                                    privileges={this.props.privileges}
                                    isOwnTeam={this.props.isOwnTeam}
                                />
                            </div>
                            <ReactTooltip id={"teamInfo"} type={"light"}>
                                <span className={"toolTipStyle"}>{this.props.t("teamInformation")}</span>
                            </ReactTooltip>
                            <ReactTooltip id={"logWindow"} type={"light"}>
                                <span className={"toolTipStyle"}>{this.props.t("eventLog")}</span>
                            </ReactTooltip>
                        </>
                    ) : null}
                </div>
            </div>
        );
    }
}

class Position extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            currentCarPosition: 0,
            positionColor: "#ffffff",
        };
    }

    render() {
        return (
            <div className={"col-xs-2 currentPositionContainerStyle"}>
                <div className={"col-xs-12 App_teamTitle"} style={{padding: 0, overflowWrap: "normal"}}>
                    {this.props.t("lap")} <b>{this.props.numLaps ? this.props.numLaps : "---"}</b>
                </div>
            </div>
        );
    }
}

class Logo extends PureComponent {
    render() {
        return (
            <>
                <div className={"col-xs-12"} style={{margin: 10, padding: 0}}>
                    <div className={"col-xs-1 text-center"} style={{marginTop: 5, paddingRight: 0}}>
                        <div
                            className={"led-" + this.props.deviceStatusLEDcolor + "-static"}
                            data-tip={true}
                            data-for={"device_on_main"}
                        ><i className={"fas fa-power-off"} style={{paddingTop: 5}}/></div>
                    </div>
                    <div className={"col-xs-1 text-center"} style={{paddingRight: 0}}>
                        <div style={{marginTop: 5, position: "relative", width: "100%"}}>
                            <i className={"fas fa-signal glow-" + this.props.gsmStatusLEDcolor + "-static"} style={{marginTop: 1, marginLeft: 0, fontSize: 21}}/>
                            <img
                                src={this.props.gsmIcon}
                                alt={""}
                                className={"glow-" + this.props.gsmStatusLEDcolor + "-static"}
                                height={24}
                                data-tip={true}
                                data-for={"gsm_main"}
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)"
                                }}/>
                        </div>
                    </div>
                    <div className={"col-xs-1 text-center"} style={{marginTop: 5}}>
                        <i className={"fas fa-satellite-dish glow-" + this.props.gpsStatusLEDcolor + "-static"} data-tip={true} data-for={"gps_main"} style={{fontSize: 24}}/>
                    </div>
                    <div className={"col-md-offset-1 col-xs-5 col-md-4 col-lg-3 App_teamTitle"} style={{paddingRight: 0}}>
                        <p>{this.props.t("poweredBy")}</p>
                    </div>
                    <div className={"col-xs-2"} style={{margin: "auto", paddingLeft: 0}}>
                        <img alt={""} src={logo} height={35} style={{maxHeight: 35, verticalAlign: "text-top"}}/>
                    </div>
                </div>
                <ReactTooltip id={"device_on_main"} type={"light"}>
                    <span className={"App_title"}>{this.props.deviceStatusTooltip}</span>
                </ReactTooltip>
                <ReactTooltip id={"gsm_main"} type={"light"}>
                    <span className={"App_title"}>{this.props.gsmStatusTooltip}</span>
                </ReactTooltip>
                <ReactTooltip id={"gps_main"} type={"light"}>
                    <span className={"App_title"}>{this.props.gpsStatusTooltip}</span>
                </ReactTooltip>
            </>
        );
    }
}

class LapTimes extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            carID: -1,
            bestLap: 0,
            bestLapOverall: 0,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.carID !== this.props.carID) {
            for (let i = 0; i < this.props.standings.std.length; i++) {
                if (this.props.standings.std[i].cid === this.props.carID) {
                    this.setState({
                        bestLap: this.props.standings.std[i].blt,
                        carID: this.props.carID,
                    });
                    break;
                }
            }
        }
        if (prevProps.bestLapPersonal !== this.props.bestLapPersonal) {
            this.setState({
                bestLap: this.props.bestLapPersonal,
            });
        }
    }

    render() {
        const gap = this.state.bestLap ? (this.state.bestLap - this.props.bestLapOverall) / 1000 : "---";
        const green = "#00ff38";
        const red = "#ff1b00";
        const lapWindowGapStyle = {
            color: (gap > 0 ? red : green),
            fontSize: 15,
            textAlign: "center",
            fontFamily: 'Kosugi Maru'
        };

        return (
            <>
                <div className={"col-xs-4 col-md-12"}>
                    <div className={"App_lapWindowContainer"}>
                        <div className={"App_smallHeader"}>{this.props.t("currentLap").toUpperCase()}</div>
                        <span className={"App_textLaptime"}>{formatTime(this.props.currentLapTime).substr(0, 8)}</span>
                    </div>
                </div>
                <div className={"col-xs-4 col-md-12"}>
                    <div className={"App_lapWindowContainer"}>
                        <div className={"App_smallHeader"}>{this.props.t("bestLap").toUpperCase()}</div>
                        <span className={"App_textLaptime"}>{formatTime(this.state.bestLap)}</span>
                        <br/>
                        <label style={lapWindowGapStyle}>
                            {(gap <= 0) ? (
                                this.props.t("fastestVehicle")
                            ) : (
                                (isNaN(gap) ? "---" : "+" + gap)
                            )}
                        </label>
                    </div>
                </div>
                <div className={"col-xs-4 col-md-12"}>
                    <div className={"App_lapWindowContainer"} style={{borderColor: "#ffcf00"}}>
                        <div className={"App_smallHeader"}>{this.props.t("bestLapOverall").toUpperCase()}</div>
                        <span className={"App_textLaptime"}>{formatTime(this.props.bestLapOverall)}</span>
                    </div>
                </div>
            </>
        );
    }
}

class LapTable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            lapsParsed: []
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.laps.lst[0].time !== this.props.laps.lst[0].time) {
            let lapsRows = [];
            for (let i = 0; i < (this.props.laps.lst.length - 1); i++) {
                let gap = 0;
                if (i !== this.props.laps.lst.length - 1) {
                    gap = (this.props.laps.lst[i].time - this.props.laps.lst[i + 1].time) / 1000;
                }
                if (this.props.laps.lst[i]) {
                    const lap = this.props.laps.lst[i];
                    lapsRows.push(
                        <tr key={lap.timestamp} className={"App_white_text"} style={{textAlign: "center"}}>
                            <td>{lap.number}</td>
                            <td>{formatTime(this.props.laps.lst[i].time)}</td>
                            <td style={(gap < 0 ? ({color: "#00ff38"}) : ({color: "#ff1b00"}))}>
                                {(gap > 0) ? ("+" + gap) : (gap)}
                            </td>
                            <td>
                                {(!isFinite(calculateAVGSpeed(this.props.laps.lst[i].time, this.props.circuitLength)) ? ("---") : (calculateAVGSpeed(this.props.laps.lst[i].time, this.props.circuitLength)))}
                            </td>
                            <td>{(this.props.laps.lst[i].max < 500 ? this.props.laps.lst[i].max : "---")}</td>
                        </tr>
                    );
                }
            }
            this.setState({
                laps: this.props.laps,
                lapsParsed: lapsRows,
            });
        }
    }

    render() {
        return (
            <div className={"table-scroll-parent App_ContainerStyle table-responsive"} style={{height: 260, borderBottomRightRadius: 35}}>
                <div className={"table-scroll-child"}>
                    <table className={"table table-condensed"}>
                        <thead>
                        <tr>
                            <th className={"App_smallHeader"}>{this.props.t("lap").toUpperCase()}</th>
                            <th className={"App_smallHeader"}>{this.props.t("time").toUpperCase()}</th>
                            <th className={"App_smallHeader"}>{this.props.t("gap").toUpperCase()}</th>
                            <th className={"App_smallHeader"}>{this.props.t("avgSpd").toUpperCase()}</th>
                            <th className={"App_smallHeader"}>{this.props.t("maxSpd").toUpperCase()}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.lapsParsed}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

class Gauges extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            numGauges: 0,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.gaugesConfig !== this.props.gaugesConfig) {
            let counter = 0;
            for (let i = 0; i < this.props.gaugesConfig.length; i++) {
                if (this.props.isGuest || this.props.isOwnTeam === 0) {
                    if (this.props.gaugesConfig[i].active === 1 && this.props.gaugesConfig[i].is_public === 1) {
                        counter++;
                    }
                } else {
                    if (this.props.gaugesConfig[i].active === 1) {
                        counter++;
                    }
                }
            }
            this.setState({
                numGauges: counter,
            });
        }
    }

    render() {
        const helper = this;
        return (
            <>
                {this.state.numGauges > 0 ? (
                    this.props.gaugesConfig.map((gauge) => {

                        if (helper.props.isGuest) {
                            if (gauge.is_public === 0) {
                                return null;
                            }
                        } else if (this.props.isOwnTeam === 0) {
                            if (gauge.is_public === 0) {
                                if (!this.props.privileges.includes(super_admin) || !this.props.privileges.includes(event_admin)) {
                                    return null;
                                }
                            }
                        }

                        if (gauge.active === 1) {
                            const realValue = this.props.telemetry[gauge.server_tag] * gauge.mult_factor;
                            return (
                                <div key={gauge.server_tag + "_obj"}>
                                    <Gauge
                                        config={gauge}
                                        realValue={Math.round(realValue * 10) / 10}
                                        cookies={this.props.cookies}
                                    />
                                </div>
                            );
                        } else {
                            return null;
                        }
                    })
                ) : (
                    <div className={"App_title"}>{this.props.t("noTelemetry").toUpperCase()}</div>
                )}
            </>
        );
    }
}

class Gauge extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            realValue: 0,
            currentColor: "#FFFFFF",
        };

        this.setupGauge = this.setupGauge.bind(this);
    }

    componentDidMount() {
        this.setupGauge();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.realValue !== this.props.realValue) {
            this.setupGauge();
        }
    }

    setupGauge() {
        if (this.props.realValue >= this.props.config.ignore_threshold) {
            this.setState({
                realValue: -1,
            });
        } else {
            this.setState({
                realValue: this.props.realValue,
            });
        }

        let currentColor = "#FFFFFF";
        if (this.props.config.has_multiple_thresholds === 1) {
            if (this.props.realValue < this.props.config.min_value) {
                currentColor = this.props.config.min_color;
            } else if (this.props.config.med_value && this.props.realValue >= this.props.config.min_value && this.props.realValue < this.props.config.med_value) {
                currentColor = this.props.config.med_color;
            } else if (this.props.config.med_value && this.props.realValue >= this.props.config.med_value && this.props.realValue < this.props.config.max_value) {
                currentColor = this.props.config.max_color;
            } else if (this.props.realValue >= this.props.config.max_value) {
                currentColor = this.props.config.max_color;
            }
        } else {
            if (this.props.realValue <= this.props.config.max_value) {
                currentColor = this.props.config.max_color;
            }
        }
        this.setState({
            currentColor: currentColor,
        });
    }

    render() {
        let barLabel;
        let finalPercentageValue;
        if (this.state.realValue < this.props.config.ignore_threshold) {
            barLabel = (this.state.realValue ? this.state.realValue : 0) + " " + this.props.config.unit;
            finalPercentageValue = Math.round((this.state.realValue * 100) / this.props.config.max_value);
        } else {
            barLabel = "---";
            finalPercentageValue = 0;
        }

        return (
            <div className={"col-xs-12 w3-animate-fading"} style={{textAlign: "center", paddingLeft: 0, margin: 10}}>
                <CustomProgressBar
                    percentage={finalPercentageValue}
                    color={this.state.currentColor}
                    label={this.props.config["label_" + this.props.cookies.get("lang")]}
                    realValue={barLabel}
                />
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(TopRow));
